import { z } from 'zod';

export const DataIntegrationTypeSchema = z.enum(['Lucity','Simplicity','CityView','Energov','Cartegraph','AssetEssentials','CityWorks','Accela','Edgesoft']);

export type DataIntegrationTypeType = `${z.infer<typeof DataIntegrationTypeSchema>}`

export default DataIntegrationTypeSchema;
